export const APPLE_STORE_APP_URL =
  "https://apps.apple.com/us/app/modus-learning-platform/id1616024916"

export const PLAY_STORE_APP_URL =
  "https://play.google.com/store/apps/details?id=eu.vallesi.ModusLearningApp"
